// PageMobile Component
/* eslint indent: 0 */

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import PageHeaderMobile from '../../mobile/page_headermobile/page_headermobile.jsx'
import FavouriteItem from '../../mobile/favourite_item/favourite_item.jsx'
import FooterMenu from '../../mobile/footer_menu/footer_menu.jsx'
import HourItem from '../../mobile/hour_item/hour_item.jsx'
import MobileForm from '../../form/mobile_form/mobile_form.jsx'
import TimeUtil from '../../../lib/timeutil.jsx'
import TimeMessage from '../../time/time_message/time_message.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class PageMobile extends PageBase {
  constructor (props) {
    super(props, 'timemobile', 'timemobile', 'timemobile', 'mobile')

    this.state = {
      dataDate: null,
      loading: true,
      activeDateTimeTaken: 0
    }

    this.data = {
      days: [
        { label: '5 hours', title: 'Sunday' },
        { label: '10 hours', title: 'Monday' },
        { label: '15 hours', title: 'Tuesday' },
        { label: '14 jul', title: 'Wednesday' },
        { label: '5 hours', title: 'Sunday' },
        { label: '10 hours', title: 'Monday' },
        { label: '15 hours', title: 'Tuesday' },
        { label: '14 jul', title: 'Wednesday' },
        { label: '5 hours', title: 'Sunday' }
      ],
      timeProjects: [],
      timeCards: [],
      favourites: [],
      editTimeCardId: null,
      stat: null
    }

    this._references = {
      mobileForm: React.createRef()
    }

    this._bUnMounted = false

    const currDate = DateUtil.getUTCCurrentDate()
    this.activeDate = new Date(
      currDate.getFullYear(),
      currDate.getMonth(),
      currDate.getDate()
    )
    this.weekNo = DateUtil.getLocalWeekNo()
    this.year = DateUtil.getLocalYear()
    this._bFormOpen = false
    this._setFABButtonState(true, false)
  }

  componentDidMount () {
    this._getData(false)
    this._initEvents()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  renderContent () {
    const headerInfo = {
      activeDate: this.activeDate,
      activeDateTime: this.state.activeDateTimeTaken
    }
    const favorites = this.data.favourites
    const timer = this._getTimer()

    return (
      <div className='pageinnercont'>
        {favorites.length > 0 && (
          <FavouriteItem
            items={favorites}
            timer={timer}
            activeDate={this.activeDate}
            onOpenForm={this._onOpenTimeEditForm.bind(this, false)}
            onCreateTimeCard={this._onCreateTimeCard.bind(this)}
          />
        )}
        <div className='grid-content'>
          {this._renderMessage()}
          {this._renderHourItems()}
        </div>
        {!this.data.editTimeCardId && (
          <FooterMenu
            timeTaken={this.state.activeDateTimeTaken}
            date={this.activeDate}
            onClickLogout={this._onLogout.bind(this)}
          />
        )}
        <MobileForm
          ref={this._references.mobileForm}
          headerInfo={headerInfo}
          projects={this.data.timeProjects}
          onSearchActivity={TimeUtil.onSearchActivity} // eslint-disable-line react/jsx-handler-names
          onSubmit={this._onSubmitAddTimeCard.bind(this)}
          onClose={this._onCloseForm.bind(this)}
        />
      </div>
    )
  }

  renderHeader () {
    return (
      <div className='mobileheaderwrap'>
        <PageHeaderMobile
          stat={this.data.stat}
          onClickDay={this._onClickDay.bind(this)}
          onPaginate={this._onPaginate.bind(this)}
        />
      </div>
    )
  }

  getContentClassname () {
    return 'mobile'
  }

  /* Private function */
  _onPaginate (bFuture) {
    this._getDataTimeCardStat(true, bFuture, () => {})
  }

  _renderSidebar () {
    return ''
  }

  _renderDialogTimeCardAdd () {
    return ''
  }

  _renderMessage () {
    if (this.state.loading) {
      return (
        <TimeMessage
          message='task.form.noTaskTitle'
          ignoreTimer
          ignoreLine
          onAdd={this._onAddManualTimeCard.bind(this)}
        />
      )
    }

    return ''
  }

  _onOpenTimeEditForm (bTimeCard, favItem) {
    const timecard = _.find(this.data.timeCards, timeCardItem => {
      if (
        favItem.projectId !== null &&
        favItem.projectId === timeCardItem.projectId &&
        favItem.activityId !== null &&
        favItem.activityId === timeCardItem.activityId
      ) {
        return timeCardItem
      } else if (
        !favItem.projectId &&
        !favItem.activityId &&
        favItem.customActivityType === timeCardItem.activity
      ) {
        return timeCardItem
      }
    })

    if (!bTimeCard && !timecard) {
      const createData = {
        projectId: favItem.projectId ? favItem.projectId : null,
        activityId: favItem.activityId ? favItem.activityId : null,
        userId: favItem.userId,
        activity: favItem.customActivityType
      }
      this._onCreateTimeCard(createData, false, true)
    } else {
      const timeCardId = bTimeCard
        ? favItem
        : timecard && timecard.id
        ? timecard.id
        : null

      this.data.editTimeCardId = timeCardId
      this.forceUpdate()
    }
  }

  _onAddManualTimeCard () {
    this._bFormOpen = true

    if (this._references.mobileForm.current) {
      this._references.mobileForm.current.show()
    }
  }

  _renderHourItems () {
    if (this.data.timeCards && this.data.timeCards.length < 0) {
      return ''
    }

    return this.data.timeCards.map((time, idx) => (
      <HourItem
        key={idx}
        hour={time}
        onSave={this._onUpdateTimeCard.bind(this)}
        onUpdateFavorite={this._onUpdateFavorite.bind(this)}
        onDelete={this._onDeleteTimeCard.bind(this)}
        active={this.data.editTimeCardId === time.id}
        onOpenForm={this._onOpenTimeEditForm.bind(this, true)}
        onCloseForm={this._onCloseTimeEditForm.bind(this)}
      />
    ))
  }

  /* _getData() {
    async.series([
      (done) => {
        this._getDataTimeCards(done);
      },
      (done) => {
        this._getFavourites(done);
      },
      (done) => {
        this._getAllDataProjects(done);
      },
      (done) => {
        this._getDataTimeCardStat(false, false, done);
      }
    ], (err, _res) => {
      this._onDataReceived(err);
    });
  } */

  _getData (bReload) {
    const activeDate = this.activeDate
    const startDate = new Date(
      activeDate.getFullYear(),
      activeDate.getMonth(),
      activeDate.getDate() - 30
    )
    const endDate = new Date(
      activeDate.getFullYear(),
      activeDate.getMonth(),
      activeDate.getDate() + 30
    )

    const params = {
      query: {
        pageIdent: this._pageIdent,
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        timecard: {
          userId: app.loggedInId,
          $client: {
            subObjects: {
              project: ['title', 'contactId'],
              contact: ['company']
            }
          }
        },
        favourite: {
          userId: app.loggedInId,
          $sort: { orderNumber: 1 },
          $client: {
            subObjects: {
              project: ['title']
            }
          }
        },
        project: {
          ignoreStatus: ['estimate', 'closed', 'completed'],
          bHasTimeActivity: false,
          filterUserId: app.loggedInId
        },
        timecardStat: {
          userId: app.loggedInId,
          weekNo: this.weekNo,
          activeDate: this.activeDate,
          isMobile: true,
          fromDate: startDate,
          toDate: endDate,
          clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
        }
      }
    }

    if (this.activeDate) {
      const currDate = this.activeDate
      params.query.timecard.createdOn = {
        $gte: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate()
        ),
        $lt: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate() + 1
        )
      }
    }

    app
      .service('/api/page/mobile')
      .find(params)
      .then(pageMobRes => {
        this._onPageDataRecieved(pageMobRes.pageData)

        const options =
          pageMobRes.projectOptions.length > 0 ? pageMobRes.projectOptions : []
        this.data.favourites = []
        this.data.timeProjects = options
        this.data.timeCards = pageMobRes.timeCards
        let favourites = []

        if (pageMobRes.stat) {
          if (this.data.stat) {
            pageMobRes.stat.days.map(dayItem => {
              const statDayItem = _.find(
                this.data.stat.days,
                obj =>
                  new Date(obj.date).getTime() ===
                  new Date(dayItem.date).getTime()
              )
              if (statDayItem) {
                statDayItem.timeTaken = dayItem.timeTaken
                statDayItem.timeTotal = dayItem.timeTotal
                statDayItem.bshowTime = dayItem.bshowTime
              } else {
                this.data.stat.days.push(dayItem)
              }
            })
          } else {
            this.data.stat = pageMobRes.stat
          }
        }

        if (this.data.stat) {
          this.data.stat.days = _.uniqBy(this.data.stat.days, obj =>
            new Date(obj.date).getTime()
          )
        }

        if (pageMobRes.favourites) {
          this.data.favourites = pageMobRes.favourites
          favourites = pageMobRes.favourites

          if (this.data.timeCards && this.data.timeCards.length > 0) {
            this.data.timeCards.map(timecard => {
              const exstFavObj = _.find(favourites, favItem => {
                if (
                  favItem.projectId !== null &&
                  favItem.projectId === timecard.projectId &&
                  favItem.activityId !== null &&
                  favItem.activityId === timecard.activityId
                ) {
                  return favItem
                } else if (
                  !favItem.projectId &&
                  !favItem.activityId &&
                  favItem.customActivityType === timecard.activity
                ) {
                  return favItem
                }
              })

              if (exstFavObj) {
                timecard.isFavorite = true
              } else {
                timecard.isFavorite = false
              }
            })
          }
        }

        this._onDataReceived(null)
      })
      .catch(err => {
        app.debug('PageMobile: _getData err', err)
        this._onDataReceived(err)
      })
  }

  _getDataTimeCards (callback) {
    const params = {
      query: {
        userId: app.loggedInId,
        $client: {
          subObjects: {
            project: ['title', 'contactId'],
            contact: ['company']
          }
        }
      }
    }

    if (this.activeDate) {
      const currDate = this.activeDate
      params.query.createdOn = {
        $gte: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate()
        ),
        $lt: new Date(
          currDate.getFullYear(),
          currDate.getMonth(),
          currDate.getDate() + 1
        )
      }
    }

    app
      .service('/api/timecard')
      .find(params)
      .then(timeRes => {
        if (timeRes) {
          this.data.timeCards = timeRes.data
        }

        callback(null)
      })
      .catch(timeErr => {
        app.debug('PageMobile: _getDataTimeCards Error', timeErr)
        callback(timeErr)
      })
  }

  _getAllDataProjects (callback) {
    this._onTimeProjectSearch(null, true, app.loggedInId, options => {
      this.data.timeProjects = options
      callback(null)
    })
  }

  _getDataTimeCardStat (bPaginate, bFuture, callback) {
    const activeDate = this.activeDate

    let startDate = new Date(
      activeDate.getFullYear(),
      activeDate.getMonth(),
      activeDate.getDate() - 30
    )
    let endDate = new Date(
      activeDate.getFullYear(),
      activeDate.getMonth(),
      activeDate.getDate() + 30
    )

    if (bPaginate) {
      if (bFuture) {
        const dayItem = this.data.stat.days[this.data.stat.days.length - 1]
        const date = new Date(dayItem.date)

        startDate = new Date(date)
        startDate.setDate(date.getDate() + 1)
        endDate = new Date(
          startDate.getFullYear(),
          startDate.getMonth(),
          startDate.getDate() + 30
        )
      } else {
        const dayItem = this.data.stat.days[0]
        const date = new Date(dayItem.date)

        endDate = new Date(date)
        endDate.setDate(date.getDate() - 1)
        startDate = new Date(
          endDate.getFullYear(),
          endDate.getMonth(),
          endDate.getDate() - 30
        )
      }
    }

    const params = {
      query: {
        userId: app.loggedInId,
        weekNo: this.weekNo,
        activeDate: bPaginate ? null : this.activeDate,
        isMobile: true,
        fromDate: startDate,
        toDate: endDate,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset()
      }
    }

    app
      .service('/api/page/timecard')
      .get(null, params)
      .then(result => {
        if (result) {
          if (bPaginate) {
            if (bFuture) {
              this.data.stat.days = this.data.stat.days.concat(result.stat.days)
            } else {
              this.data.stat.days = result.stat.days.concat(this.data.stat.days)
            }
          } else if (this.data.stat) {
            this.data.stat.days = this.data.stat.days.concat(result.stat.days)
          } else {
            this.data.stat = result.stat
          }
        }

        this.data.stat.days = _.uniqBy(this.data.stat.days, obj =>
          new Date(obj.date).getTime()
        )

        const activeTimeTaken = this._getActiveTimeTaken(
          this.data.stat.days,
          this.activeDate
        )

        this.setState({ activeDateTimeTaken: activeTimeTaken })
        callback(null)
      })
      .catch(err => {
        app.debug('PageMobile: _getDataTimeCardStat err', err)
        callback(err)
      })
  }

  _getActiveTimeTaken (days, activeDate) {
    let activeTimeTaken = 0
    days.map(obj => {
      const date = new Date(obj.date)
      if (
        date.getFullYear() === activeDate.getFullYear() &&
        date.getMonth() === activeDate.getMonth() &&
        date.getDate() === activeDate.getDate()
      ) {
        activeTimeTaken = obj.timeTaken
      }
    })

    return activeTimeTaken
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageMobile: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this.setState({ dataDate: new Date(), loading: true })
    } else {
      app.debug('PageMobile: _onDataReceived [done]')

      if (this.data.timeCards && this.data.timeCards.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }

      const activeTimeTaken = this._getActiveTimeTaken(
        this.data.stat.days,
        this.activeDate
      )

      this.setState({
        dataDate: new Date(),
        loading: !(this.data.timeCards && this.data.timeCards.length > 0),
        activeDateTimeTaken: activeTimeTaken
      })
    }
  }

  _getFavourites (callback) {
    this.data.favourites = []

    let favourites = []
    async.series(
      [
        done => {
          const favParams = {
            query: {
              userId: app.loggedInId,
              $sort: { orderNumber: 1 },
              $client: {
                subObjects: {
                  project: ['title']
                }
              }
            }
          }

          app
            .service('/api/timecard/favorite')
            .find(favParams)
            .then(favRes => {
              if (favRes && favRes.total > 0) {
                this.data.favourites = favRes.data
                favourites = favRes.data

                if (this.data.timeCards && this.data.timeCards.length > 0) {
                  this.data.timeCards.map(timecard => {
                    const exstFavObj = _.find(favourites, favItem => {
                      if (
                        favItem.projectId !== null &&
                        favItem.projectId === timecard.projectId &&
                        favItem.activityId !== null &&
                        favItem.activityId === timecard.activityId
                      ) {
                        return favItem
                      } else if (
                        !favItem.projectId &&
                        !favItem.activityId &&
                        favItem.customActivityType === timecard.activity
                      ) {
                        return favItem
                      }
                    })

                    if (exstFavObj) {
                      timecard.isFavorite = true
                    } else {
                      timecard.isFavorite = false
                    }
                  })
                }
              }

              done(null)
            })
            .catch(favErr => {
              app.debug('PageTime: _getFavourites Error', favErr)
              done(favErr)
            })
        }
      ],
      (asynErr, _asyncRes) => {
        if (asynErr) {
          app.debug('Page contact: _onClickSetting err', asynErr)
          callback(asynErr)
        } else {
          callback(null)
        }
      }
    )
  }

  _onUpdateFavorite (timecard, bFavorite) {
    const exstFavObj = _.find(this.data.favourites, favItem => {
      if (
        favItem.projectId !== null &&
        favItem.projectId === timecard.projectId &&
        favItem.activityId !== null &&
        favItem.activityId === timecard.activityId
      ) {
        return favItem
      } else if (
        !favItem.projectId &&
        !favItem.activityId &&
        favItem.customActivityType === timecard.activity
      ) {
        return favItem
      }
    })

    if (!exstFavObj || !bFavorite) {
      TimeUtil.updateFavorite(timecard, bFavorite, _updateRes => {
        this._reloadData()
      })
    }
  }

  _reloadData () {
    this._getData(true)
  }

  _getItemExists (timecardItems, timecard) {
    const existsObj = _.find(timecardItems, obj => {
      if (timecard.projectId && timecard.activityId) {
        // Project budget activity
        return (
          obj.projectId === timecard.projectId &&
          obj.activityId === timecard.activityId
        )
      }
    })

    return existsObj
  }

  /* Event handlers */
  _onSubmitAddTimeCard (timeCard, bOpen) {
    this._onCreateTimeCard(timeCard, false, false, () => {
      if (this._references.mobileForm.current) {
        this._references.mobileForm.current.hide()
      }

      this._reloadData()

      if (bOpen) {
        if (this._references.mobileForm.current) {
          this._references.mobileForm.current.show()
          this._references.mobileForm.current.showMessage(
            'time.form.addSuccessInfo',
            'time.form.addSuccessMsg',
            true
          )
        }

        this._bFormOpen = true
      } else {
        this._bFormOpen = false
      }
    })
  }

  onAdd () {
    if (this._references.mobileForm.current) {
      this._references.mobileForm.current.show()
    }
  }

  _onCloseForm () {
    if (this._references.mobileForm.current) {
      this._references.mobileForm.current.hide()
    }
  }

  _onClickDay (date, _timeTaken) {
    this.activeDate = date
    this._reloadData()
  }

  _onLogout () {
    app.logout()
  }

  _onCloseTimeEditForm () {
    this.data.editTimeCardId = null
    this.forceUpdate()
  }

  _onUpdateTimeCard (timecardId, updateObj, callback) {
    app
      .service('/api/timecard')
      .patch(timecardId, updateObj)
      .then(_updateRes => {
        this.data.editTimeCardId = null
        callback(null)
      })
      .catch(createErr => {
        app.debug('PageMobile: _onUpdateTimeCard Error', createErr)
        callback(createErr)
      })
  }

  _onDeleteTimeCard (timecardId) {
    if (!timecardId) {
      return false
    }

    app
      .service('/api/timecard')
      .remove(timecardId)
      .then(_removeRes => {})
      .catch(createErr => {
        app.debug('PageMobile: _onDeleteTimeCard Error', createErr)
      })
  }

  _onCreateTimeCard (timeCard, bStartTimer, bEditTimeCard, callback) {
    if (timeCard) {
      const createObj = _.cloneDeep(timeCard)
      const bIsFavorite = createObj.isFavorite
      delete createObj.isFavorite
      delete createObj.favouriteId

      createObj.userId = app.loggedInId
      createObj.projectId = timeCard.projectId
      createObj.activityId = timeCard.activityId
      createObj.activity = timeCard.activity
      createObj.createdOn = this.activeDate

      TimeUtil.createTimeCard(createObj, createRes => {
        const newTimecardId = createRes.id
        this.data.editTimeCardId = bEditTimeCard ? newTimecardId : null

        if (bIsFavorite) {
          TimeUtil.createFavorite(createRes, null)
        }

        if (callback) {
          callback(createRes)
        }
      })
    }
  }

  /* Realtime Events */
  _initEvents () {
    this._initTimerEvents(this._onReloadTimer.bind(this))

    this._eventHandlers.timeCardCreated = this._eventReload.bind(
      this,
      'TimeCard',
      'Created'
    )
    this._eventHandlers.timeCardUpdated = this._eventReload.bind(
      this,
      'TimeCard',
      'Updated'
    )
    this._eventHandlers.timeCardRemoved = this._eventReload.bind(
      this,
      'TimeCard',
      'Removed'
    )
    this._eventHandlers.timeCardPatched = this._eventReload.bind(
      this,
      'TimeCard',
      'Patched'
    )

    const timeCardService = app.service('/api/timecard')
    timeCardService.on('created', this._eventHandlers.timeCardCreated)
    timeCardService.on('updated', this._eventHandlers.timeCardUpdated)
    timeCardService.on('removed', this._eventHandlers.timeCardRemoved)
    timeCardService.on('patched', this._eventHandlers.timeCardPatched)
  }

  _releaseEvents () {
    this._releaseTimerEvents()

    const timeCardService = app.service('/api/timecard')
    timeCardService.off('created', this._eventHandlers.timeCardCreated)
    timeCardService.off('updated', this._eventHandlers.timeCardUpdated)
    timeCardService.off('removed', this._eventHandlers.timeCardRemoved)
    timeCardService.off('patched', this._eventHandlers.timeCardPatched)

    this._eventHandlers.timeCardCreated = null
    this._eventHandlers.timeCardUpdated = null
    this._eventHandlers.timeCardRemoved = null
    this._eventHandlers.timeCardPatched = null
  }

  _onReloadTimer (eventData) {
    if (eventfilters.teamFilter(eventData)) {
      this._reloadData()
    }
  }

  _eventReload (objectName, eventName, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageMobile - ${objectName} - ${eventName} --`)
      this._reloadData()
    }
  }
}

export default PageMobile
